import React, { useContext } from 'react';
// import { ThemeContext } from '../../ContextProvider/ThemeContext';
import styles from './Experiences.module.css';

const Experiences = () => {
	// const { newTheme } = useContext(ThemeContext);
	return (
		<div className={styles.experiences}>
			{/*  */}
		</div>
	);
};

export default Experiences;
